import { render, staticRenderFns } from "./perseo_despachos_export_ruta.vue?vue&type=template&id=f8f6dae8&scoped=true"
import script from "./perseo_despachos_export_ruta.vue?vue&type=script&lang=js"
export * from "./perseo_despachos_export_ruta.vue?vue&type=script&lang=js"
import style0 from "./perseo_despachos_export_ruta.vue?vue&type=style&index=0&id=f8f6dae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f6dae8",
  null
  
)

export default component.exports